import classnames from "classnames";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { viewMsgMember } from "../../../redux/actions";
import { useRedux } from "hooks";
import 'react-circular-progressbar/dist/styles.css';

interface SenderMsgInfoProps {
    isSent: boolean,
    sentDate: any,
    readPcnt: number | undefined,
    msgId: string | number,
    onViewReadStatus: (mId: string) => void,
    senderId?:number|null,
}



const LoadingCircle = () => {
    return (
        <div className="spinner-border spinner-border-sm text-secondary" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
    );
}



const SenderMsgInfo = ({
    isSent, sentDate, readPcnt, msgId, onViewReadStatus, senderId
}: SenderMsgInfoProps) => {
    const { dispatch, useAppSelector } = useRedux();

    const loadingPcntClick = (msgId: string | number) => {
        onViewReadStatus(msgId as string);
    }

    const LoadingPcnt = (pcnt: number, msgId: string | number) => {
        return (
            <div style={{ width: '15px', height: '22px' }} onClick={() => loadingPcntClick(msgId)}>
                {/* <CircularProgressbar
                    value={pcnt}
                    text={``}
                    strokeWidth={25}
                    className={"circular-read"}
                    styles={buildStyles({
                        pathColor: pcnt === 100 ? 'green' : 'green',
                        textColor: 'black',
                        trailColor: '#c0d9be',
                    })}

                /> */}

                <CircularProgressbar
                        value={pcnt}
                        strokeWidth={50}
                        styles={buildStyles({
                        strokeLinecap: "butt",
                        pathColor: pcnt === 100 ? 'green' : 'green',
                        textColor: 'black',
                        trailColor: '#c0d9be',          
                        })}
                    />

                
            </div>
        );
    }

    // console.log({ isSent, sentDate, readPcnt });
    return (
        <>
            <span className="me-1">
                {!isSent && <LoadingCircle />}
                {isSent && LoadingPcnt(readPcnt ?? 0, msgId)}
            </span>
            <small className={classnames("text-muted", "mb-0", "me-0")}>
                {sentDate}, You
            </small>
            {/* You */}
        </>
    );
}

export default SenderMsgInfo
